<template>
    <div class="l-body">
        <div class="l-menu" @click="taskEvent(taskFlag)">备战资源</div>
        <div class="l-red" v-if="isRead"></div>
        <LTask :visible="taskFlag" :list="listData" @closeTask="taskEvent(taskFlag)" />
    </div>
</template>
<script>
import LTask from "./components/l-task/l-task";
export default {
    name: "preparation",

    components: {
        LTask,
    },
    data() {
        return {
            taskFlag: false,
            listData: [],
            isRead: false
        };
    },
    
    methods: {
        taskEvent() {
            this.taskFlag = !this.taskFlag;

        },
    },
};
</script>
<style lang="stylus" scoped>
@import url('./css/index.styl');
</style>
